import {
    Button, Container, Dialog, DialogTitle, Grid, Paper, styled, Table, TableBody, TableCell,
    tableCellClasses,
    TableContainer, TableHead, TableRow, TextField,
} from '@mui/material'
import React, { useEffect } from 'react'
import { useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import BillingService from '../../Services/billing/BillingService';
import Home from '../home/Home';
import Snacbar from '../Snacbar';
import { getUserId } from '../Utils/Common';
import HashLoader from "react-spinners/HashLoader";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from "react-router";
import { ToggleButton } from '@mui/material';

const CssTextField = styled(TextField)({
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: 'black',
            fontFamily: 'Times New Roman',
        }
    },
});
const ItemPap = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    textAlign: 'center',
    height: 640,
    color: theme.palette.text.secondary,
    border: '1px solid black'
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    // textAlign: 'center',
    height: 640,
    color: theme.palette.text.secondary,
    border: '1px solid black'
}));
const ItemPap2 = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    textAlign: 'right',
    height: 640,
    color: theme.palette.text.secondary,
    border: '1px solid black'
}));
const Itemone = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    border: '1px solid black'
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: 'rgb(61, 195, 177)',
        color: theme.palette.common.black,
        textAlign: 'center',
        padding: theme.spacing(0.5),
        fontFamily: 'Times New Roman',
        fontWeight: 'bold',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 15,
        color: 'darkblue',
        fontFamily: 'Times New Roman',
        textAlign: 'center'
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
}));
function JobAuditing(props) {
    const [JobAuditingValues, setJobAuditingValues] = useState({
        jobno: '', disable_jobno: '', iec_code: '', name: '', cha_code: '', branch_Srno: '',
        address1: '', address2: '', city: '', state: '', pincode: '', adcode: '', edi_jobNo: '',
        cusHouseCode: '', disable_cusHouseCode: '', branch: '', forwarder: '', transist_mode: '',
        disable_transist_mode: '', certificate: '', bond: '', container: '', betype: '', kacha: '',
        hss: '', sec48: '', beNo: '', BeDate: '',

        certificateNo: '', certificateType: '', certificateDate: '', bondNo: '', bondCode: '',
        bondPort: '', bondAmount: '', bgDebited: '', bgRate: '', bgAmount: '', containerNo: '',
        containerSize: '', lclFcl: '', sealNo: '', truckNo: '', ieccode: '', branchSrno: '',
        precidingLvl: '', hss_name: '', hss_adres1: '', hss_adres2: '', hss_city: '', hss_state: '',
        hss_pincode: '', Permissioncode: '', addsec48_name: '', Permission_Description: '',
    });

    const [jobAuitDialogValues, setjobAuitDialogValues] = useState({
        remark: ''
    })

    const [nonAuditDetails, setNonAuditDetails] = useState([]);
    const [AuditDetails, setAuditDetails] = useState([]);
    const [AuditInvDetails, setAuditInvDetails] = useState([]);
    const [AuditItmDetails, setAuditItmDetails] = useState([]);
    const [Filtereddetails, setFiltereddetails] = useState([]);
    const [auditFiltereddetails, setauditFiltereddetails] = useState([]);
    const [loading, setloading] = useState(false)
    const [auditdsa, setAuditdsa] = useState(true);
    const [Nonauditdsa, setNonAuditdsa] = useState(true);
    const [Querydsa, setQuerydsa] = useState(true);

    const [viewInvocie, setviewInvocie] = useState(false);
    const [viewItem, setviewItem] = useState(false);

    const [Auditt, setAuditt] = useState(false);
    const [Nonauditt, setNonAuditt] = useState(false);
    const [Query, setQuery] = useState(false);
    const [selected, setSelected] = useState([]);

    const [open, setopen] = useState(false);
    const [severit, setseverit] = useState('');
    const [message, setmessage] = useState('');
    // clickhandle
    const searchJob = () => {
        var consigmnt = '';
        if (JobAuditingValues.jobno === '') { consigmnt = '-1' }
        else { consigmnt = JobAuditingValues.jobno }
        let details = { importer_iec_no: '-1', consignmentNumber: consigmnt, status: '18' }
        BillingService.getJobNoBasedImpCMNonUploadCL(details).then(res => { setNonAuditDetails(res.data); });
        BillingService.getJobNoBasedImpCMUploadCL(details).then(res => { setAuditDetails(res.data); });
    }

    const audit = () => {
        if (JobAuditingValues.disable_jobno === '') {
            setopen(true); setseverit('warning');
            setmessage('Kindly Select Job No from Left Side Job table');
        } else {
            setAuditdsa(true);
            setAuditt(true);
            let details = { consignmentId: JobAuditingValues.disable_jobno, status: '8', createdBy: getUserId() }
            BillingService.UploadBilling(details).then(res => {
                setAuditdsa(true); setAuditt(false);
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setmessage('Audit ' + message.toString()); setopen(true); setseverit('success');
                } else {
                    setmessage('Audit Failed ' + message.toString()); setopen(true); setseverit('error');
                } getData(); resetall();
            }).catch(error => {
                setopen(true); setseverit('error');
                setmessage('Audit Failed ' + error.message); resetall();
            });
        }
    }
    const Nonaudit = () => {
        if (JobAuditingValues.disable_jobno === '') {
            setopen(true);
            setseverit('warning');
            setmessage('Kindly Select Job No from Right Side Job table');
        } else {
            setNonAuditdsa(true); setNonAuditt(true);
            let details = { consignmentId: JobAuditingValues.disable_jobno, status: '9', createdBy: getUserId() }
            BillingService.UploadBilling(details).then(res => {
                setNonAuditdsa(true); setNonAuditt(false);
                if (res.data.message.toString() === 'SUCCESS') {
                    setopen(true); setseverit('success');
                    setmessage(res.data.message);
                } else {
                    setopen(true); setseverit('error');
                    setmessage('Non-Audit Failed ' + res.data.message);
                } getData(); resetall();
            }).catch(error => {
                setopen(true); setseverit('error');
                setmessage('Non-Audit Failed ' + error.message); resetall();
            });
        }
    }

    //dialogOnclick
    const updateQryRemarks = () => {
        let details = { consignmentNumber: JobAuditingValues.disable_jobno, remarks: jobAuitDialogValues.remark }
        BillingService.updateQuery(details).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') { setopen(true); setseverit('success'); setmessage('UPDATE ' + message.toString()); }
            else { setopen(true); setseverit('error'); setmessage('Update Failed ' + message.toString()); }
        }).catch(error => { setopen(true); setseverit('error'); setmessage('Update Failed ' + error.message); })
    }

    //onchange
    const JobAuditingjobnoChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, jobno: e.target.value });
    }
    const JobAuditingiec_codeChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, iec_code: e.target.value })
    }
    const JobAuditingnameChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, name: e.target.value })
    }
    const JobAuditingcha_codeChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, cha_code: e.target.value })
    }
    const JobAuditingbranch_SrnoChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, branch_Srno: e.target.value })
    }
    const JobAuditingaddress1ChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, address1: e.target.value })
    }
    const JobAuditingaddress2ChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, address2: e.target.value })
    }
    const JobAuditingcityChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, city: e.target.value })
    }
    const JobAuditingstateChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, state: e.target.value })
    }
    const JobAuditingpincodeChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, pincode: e.target.value })
    }
    const JobAuditingadcodeChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, adcode: e.target.value })
    }
    const JobAuditingedi_jobNoChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, edi_jobNo: e.target.value })
    }
    const JobAuditingcusHouseCodeChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, cusHouseCode: e.target.value })
    }
    const JobAuditingdisable_cusHouseCodeChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, disable_cusHouseCode: e.target.value })
    }
    const JobAuditingbranchChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, branch: e.target.value })
    }
    const JobAuditingforwarderChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, forwarder: e.target.value })
    }
    const JobAuditingtransist_modeChangeHandle = (e) => {
        if (e.target.value === 'A' || e.target.value === 'L' || e.target.value === 'S' || e.target.value === 'a' || e.target.value === 'l' || e.target.value === 's') {
            setJobAuditingValues({ ...JobAuditingValues, transist_mode: e.target.value })
        }
    }
    const JobAuditingdisable_transist_modeChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, disable_transist_mode: e.target.value })
    }
    const JobAuditingcertificateChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y') {
            certificateOnClickOpen();
            setJobAuditingValues({ ...JobAuditingValues, certificate: e.target.value });
        }
        else if (e.target.value === 'N' || e.target.value === 'n' || e.target.value === '') {
            setJobAuditingValues({ ...JobAuditingValues, certificate: e.target.value })
        }
    }
    const JobAuditingbondChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y' || e.target.value === 'N' || e.target.value === 'n' || e.target.value === '') {
            setJobAuditingValues({ ...JobAuditingValues, bond: e.target.value })
        }
    }
    const JobAuditingcontainerChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y' || e.target.value === 'N' || e.target.value === 'n' || e.target.value === '') {
            setJobAuditingValues({ ...JobAuditingValues, container: e.target.value })
        }
    }
    const JobAuditingbetypeChangeHandle = (e) => {
        if (e.target.value === 'h' || e.target.value === 'w' || e.target.value === 'x' || e.target.value === 'H' || e.target.value === 'W' || e.target.value === 'X' || e.target.value === '') {
            setJobAuditingValues({ ...JobAuditingValues, betype: e.target.value })
        }
    }
    const JobAuditingkachaChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y' || e.target.value === 'N' || e.target.value === 'n' || e.target.value === '') {
            setJobAuditingValues({ ...JobAuditingValues, kacha: e.target.value })
        }
    }
    const JobAuditinghssChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y' || e.target.value === 'N' || e.target.value === 'n' || e.target.value === '') {
            setJobAuditingValues({ ...JobAuditingValues, hss: e.target.value })
        }
    }
    const JobAuditingsec48ChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y' || e.target.value === 'N' || e.target.value === 'n' || e.target.value === '') {
            setJobAuditingValues({ ...JobAuditingValues, sec48: e.target.value })
        }
    }
    const JobAuditingbeNoChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, beNo: e.target.value })
    }
    const JobAuditingBeDateChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, BeDate: e.target.value })
    }
    const JobAuditingcertificateNoChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, certificateNo: e.target.value })
    }
    const JobAuditingcertificateTypeChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, certificateType: e.target.value })
    }
    const JobAuditingcertificateDateChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, certificateDate: e.target.value })
    }
    const JobAuditingbondNoChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, bondNo: e.target.value })
    }
    const JobAuditingbondCodeChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, bondCode: e.target.value })
    }
    const JobAuditingbondPortChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, bondPort: e.target.value })
    }
    const JobAuditingbondAmountChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, bondAmount: e.target.value })
    }
    const JobAuditingbgDebitedChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, bgDebited: e.target.value })
    }
    const JobAuditingbgRateChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, bgRate: e.target.value })
    }
    const JobAuditingbgAmountChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, bgAmount: e.target.value })
    }
    const JobAuditingcontainerNoChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, containerNo: e.target.value })
    }
    const JobAuditingcontainerSizeChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, containerSize: e.target.value })
    }
    const JobAuditinglclFclChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, lclFcl: e.target.value })
    }
    const JobAuditingsealNoChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, sealNo: e.target.value })
    }
    const JobAuditingtruckNoChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, truckNo: e.target.value })
    }
    const JobAuditingieccodeChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, iec_code: e.target.value })
    }
    const JobAuditingbranchSrnoChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, branch_Srno: e.target.value })
    }
    const JobAuditingprecidingLvlChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, precidingLvl: e.target.value })
    }
    const JobAuditinghss_nameChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, hss_name: e.target.value })
    }
    const JobAuditinghss_adres1ChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, hss_adres1: e.target.value })
    }
    const JobAuditinghss_adres2ChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, hss_adres2: e.target.value })
    }
    const JobAuditinghss_cityChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, hss_city: e.target.value })
    }
    const JobAuditinghss_stateChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, hss_state: e.target.value })
    }
    const JobAuditinghss_pincodeChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, hss_pincode: e.target.value })
    }
    const JobAuditingPermissioncodeChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, Permissioncode: e.target.value })
    }
    const JobAuditingaddsec48_nameChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, addsec48_name: e.target.value })
    }
    const JobAuditingPermission_DescriptionChangeHandle = (e) => {
        setJobAuditingValues({ ...JobAuditingValues, Permission_Description: e.target.value })
    }

    const addQueryRemarksChangehandle = (e) => {
        setjobAuitDialogValues({ ...jobAuitDialogValues, remark: e.target.value });
    }

    // dialogbox============>>

    const [certificateHandleOpen, setcertificateHandleOpen] = useState(false)
    const [bondHandleOpen, setbondHandleOpen] = useState(false)
    const [containerHandleOpen, setcontainerHandleOpen] = useState(false)
    const [hssHandleOpen, sethssHandleOpen] = useState(false)
    const [sec48HandleOpen, setsec48HandleOpen] = useState(false)
    const [addQuery, setaddQuery] = useState(false)


    const certificateOnClickClose = () => {
        setcertificateHandleOpen(false)
    }
    const certificateOnClickOpen = () => {
        setcertificateHandleOpen(true)
    }
    const bondOnClickClose = () => {
        setbondHandleOpen(false)
    }
    const bondOnClickOpen = () => {
        setbondHandleOpen(true)
    }
    const containerOnClickClose = () => {
        setcontainerHandleOpen(false)
    }
    const containerOnClickOpen = () => {
        setcontainerHandleOpen(true)
    }
    const hssOnClickClose = () => {
        sethssHandleOpen(false)
    }
    const hssOnClickOpen = () => {
        sethssHandleOpen(true)
    }
    const sec48OnClickClose = () => {
        setsec48HandleOpen(false)
    }
    const sec48OnClickOpen = () => {
        setsec48HandleOpen(true)
    }
    const QueryCloseHandle = () => {
        setaddQuery(false); setjobAuitDialogValues({ ...jobAuitDialogValues, remark: '' });
    }
    const QueryOpenHandle = () => {
        setaddQuery(true); setjobAuitDialogValues({ ...jobAuitDialogValues, remark: '' });
    }

    // onKeyDown============>>
    const JobAud_certificateOnkeyDown = (e) => {
        if (e.key === 'Enter') {
            if (JobAuditingValues.certificate === 'Y' || JobAuditingValues.certificate === 'y') {
                certificateOnClickOpen();
            }
        }
    }
    const JobAud_bondOnkeyDown = (e) => {
        if (e.key === 'Y' || e.key === 'y') {
            bondOnClickOpen();
            setJobAuditingValues({ ...JobAuditingValues, certificate: e.key })
        }
    }
    const JobAud_containerOnkeyDown = (e) => {
        if (e.key === 'Y' || e.key === 'y') {
            containerOnClickOpen();
            setJobAuditingValues({ ...JobAuditingValues, container: e.key })
        }
    }
    const JobAud_hssOnkeyDown = (e) => {
        if (e.key === 'Y' || e.key === 'y') {
            hssOnClickOpen();
            setJobAuditingValues({ ...JobAuditingValues, hss: e.key })
        }
    }
    const JobAud_sec48OnkeyDown = (e) => {
        if (e.key === 'Y' || e.key === 'y') {
            sec48OnClickOpen();
            setJobAuditingValues({ ...JobAuditingValues, sec48: e.key })
        }
    }

    const getData = async () => {
        BillingService.getnonAudit('18').then(res => { setNonAuditDetails(res.data); setFiltereddetails(res.data) });
        BillingService.getAudit('18').then(res => { setAuditDetails(res.data); setauditFiltereddetails(res.data) });
    }

    const getdataItmInvic = (item) => {
        var flag = '';
        if (item.receiverMailId === 'IMPORT') {
            flag = 1;
            let assigndetails = { consignmentId: item.consignmentNumber, consignmentNumber: '-1', flag: 1 }
            BillingService.getConsignmentJobEntryAssign(assigndetails).then(res => {
                const data = res.data;
                const lastResult = data.map((trns) => trns);
                console.log('values==>' + JSON.stringify(lastResult[0]))
                setJobAuditingValues({
                    ...JobAuditingValues, disable_jobno: lastResult[0].consignmentNumber, iec_code: lastResult[0].importer_iec_no,
                    name: lastResult[0].importer_name, branch_Srno: lastResult[0].branchId, address1: lastResult[0].importerAddress,
                    address2: lastResult[0].importerAddress1, disable_transist_mode: lastResult[0].transitTypeName,
                    state: lastResult[0].deliveryStateName, transist_mode: lastResult[0].transitTypeId,
                    betype: lastResult[0].typeBoeCode, kacha: lastResult[0].kacha, hss: lastResult[0].hss, sec48: lastResult[0].secFourEdight,
                    container: lastResult[0].beContainer, cusHouseCode: lastResult[0].cusHouseCode,
                    cha_code: lastResult[0].chaCode, branch: lastResult[0].regionalName,
                    forwarder: lastResult[0].freightFwdName, beNo: lastResult[0].beNo,
                    BeDate: lastResult[0].beDate, adcode: lastResult[0].ad_code, edi_jobNo: lastResult[0].userJobNo,
                    bond: lastResult[0].bond, certificate: lastResult[0].certificate, city: lastResult[0].city
                });
            }).catch(error => {
                setopen(true); setmessage(error.message); setseverit('error');
            });
        } else {
            flag = 2;

            let assigndetailsEx = { consignmentId: item.consignmentNumber, consignmentNumber: '-1', flag: 1 }
            BillingService.getConsignmentJobEntryAssignExport(assigndetailsEx).then(res => {
                const data = res.data;
                const lastResult = data.map((trns) => trns);
                setJobAuditingValues({
                    ...JobAuditingValues, disable_jobno: lastResult[0].consignmentNumber, iec_code: lastResult[0].importer_iec_no,
                    name: lastResult[0].importer_name, branch_Srno: lastResult[0].branchId, address1: lastResult[0].importerAddress, address2: lastResult[0].importerAddress1, disable_transist_mode: lastResult[0].transitTypeName,
                    state: lastResult[0].deliveryStateName, transist_mode: lastResult[0].transitTypeId, betype: lastResult[0].typeBoeCode, kacha: lastResult[0].kacha, hss: lastResult[0].hss, sec48: lastResult[0].secFourEdight,
                    container: lastResult[0].beContainer, cusHouseCode: lastResult[0].cusHouseCode, cha_code: lastResult[0].chaCode, branch: lastResult[0].regionalName,
                    forwarder: lastResult[0].freightFwdName, beNo: lastResult[0].beNo, BeDate: lastResult[0].beDate, adcode: lastResult[0].ad_code, edi_jobNo: lastResult[0].userJobNo,
                    bond: lastResult[0].bond, certificate: lastResult[0].certificate
                });
            }).catch(error => {
                setopen(true); setmessage(error.message); setseverit('error');
            });
        }
        let invdetail = { consignmentNumber: item.consignmentNumber, flag: flag }
        BillingService.getJobBasedInvoice(invdetail).then((res) => { setAuditInvDetails(res.data); });
        let iTemdetail = { consignmentNumber: item.consignmentNumber, invoiceNumber: '-1', flag: flag }
        BillingService.getJobBasedItem(iTemdetail).then((res) => { setAuditItmDetails(res.data); });
    }

    const editNonAudit = (item) => {
        const selectedIndex = selected.indexOf(item.consignmentNumber);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected, item.consignmentNumber);
        }
        setSelected(newSelected);

        setAuditdsa(false); setNonAuditdsa(true); setQuerydsa(true);
        setAuditt(false); setNonAuditt(false); setQuery(false);
        getdataItmInvic(item);
    }
    const isSelected = (name) => selected.indexOf(name) !== -1;

    const editAudit = (item) => {
        const selectedIndex = selected.indexOf(item.consignmentNumber);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected, item.consignmentNumber);
        }
        setSelected(newSelected);

        setAuditdsa(true); setNonAuditdsa(false); setQuerydsa(false);
        setAuditt(false); setNonAuditt(false); setQuery(false);
        getdataItmInvic(item);
    }
    const isitemSelected = (name) => selected.indexOf(name) !== -1;

    const resetall = () => {
        getData();
        setJobAuditingValues({
            ...JobAuditingValues, jobno: '', disable_jobno: '', iec_code: '', name: '', cha_code: '', branch_Srno: '',
            address1: '', address2: '', city: '', state: '', pincode: '', adcode: '', edi_jobNo: '',
            cusHouseCode: '', disable_cusHouseCode: '', branch: '', forwarder: '', transist_mode: '',
            disable_transist_mode: '', certificate: '', bond: '', container: '', betype: '', kacha: '',
            hss: '', sec48: '', beNo: '', BeDate: '', certificateNo: '', certificateType: '', certificateDate: '',
            bondNo: '', bondCode: '', bondPort: '', bondAmount: '', bgDebited: '', bgRate: '', bgAmount: '',
            containerNo: '', containerSize: '', lclFcl: '', sealNo: '', truckNo: '', ieccode: '', branchSrno: '',
            precidingLvl: '', hss_name: '', hss_adres1: '', hss_adres2: '', hss_city: '', hss_state: '',
            hss_pincode: '', Permissioncode: '', addsec48_name: '', Permission_Description: ''
        });
        setAuditInvDetails([]); setAuditItmDetails([]);
        setAuditdsa(true); setNonAuditdsa(true); setQuerydsa(true);
        setAuditt(false); setNonAuditt(false); setQuery(false);
    }
    const viewInvoiceDetailsOpen = () => {
        setviewInvocie(true)
    }
    const viewInvoiceDetailsClose = () => {
        setviewInvocie(false)
    }
    const viewItemDetailsOpen = () => {
        setviewItem(true)
    }
    const viewItemDetailsClose = () => {
        setviewItem(false)
    }
    const handleClose = () => {
        setopen(false);
    }

    useEffect(() => {
        setloading(true)
        setTimeout(() => {
            setloading(false)
        }, 1000)
        const getData = async () => {
            BillingService.getnonAudit('18').then(res => { setNonAuditDetails(res.data); setFiltereddetails(res.data) });
            BillingService.getAudit('18').then(res => { setAuditDetails(res.data); setauditFiltereddetails(res.data) });
        }
        getData();
    }, [])
    //table search
    const NonauditJobSrch = () => {
        return <input className="searchBoxes" onChange={(e) => { NonauditJobOnchange(e.target.value) }} placeholder="Search" />
    }
    const NonauditJobOnchange = (searchedVal) => {
        const FilterValues = nonAuditDetails.filter((trns) => {
            return trns.consignmentNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
        })
        if (searchedVal.length < 1) {
            setFiltereddetails(nonAuditDetails)
        } else {
            setFiltereddetails(FilterValues)
        }
    }
    //table search
    const auditJobSrch = () => {
        return <input className="searchBoxes" style={{ width: '52%' }} onChange={(e) => { auditJobOnchange(e.target.value) }} placeholder="Search" />
    }
    const auditJobOnchange = (searchedVal) => {
        const FilterValues = AuditDetails.filter((trns) => {
            return trns.consignmentNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
        })
        if (searchedVal.length < 1) {
            setauditFiltereddetails(AuditDetails)
        } else {
            setauditFiltereddetails(FilterValues)
        }
    }

    const navigate = useNavigate();
    const BackBotton = () => {
        navigate('/fundrefund');
    }
    const ForwordBotton = () => {
        navigate('/conslBills');
    }
    return (
        <div>
            <Snacbar open={open} message={message} severity={severit} onClose={handleClose} />
            <div>
                <Dialog open={certificateHandleOpen} onClose={certificateOnClickClose} fullWidth={true} maxWidth='md'>
                    <DialogTitle align='center' className=" p-1 bg-info" style={{ fontFamily: 'Times New Roman' }}>
                        Add Certificate  Details
                    </DialogTitle >
                    <div className='dialogboxtitlecolour'>
                        <div><Container className="mb-2 mt-4">
                            <center><CssTextField size='small' style={{ fontFamily: 'Times New Roman', width: '40%', backgroundColor: 'white' }} value={JobAuditingValues.certificateNo} onChange={JobAuditingcertificateNoChangeHandle}
                                label="Certificate No" variant="outlined" /></center>
                            <center className="mb-2 mt-2"><CssTextField size='small' style={{ fontFamily: 'Times New Roman', width: '40%', backgroundColor: 'white' }} value={JobAuditingValues.certificateType} onChange={JobAuditingcertificateTypeChangeHandle}
                                label="Certificate Type" variant="outlined" /></center>
                            <center><CssTextField size='small' style={{ fontFamily: 'Times New Roman' }} id="date" label="Certificate Date" type="date" sx={{ width: 150 }} value={JobAuditingValues.certificateDate} onChange={JobAuditingcertificateDateChangeHandle}
                                InputLabelProps={{ shrink: true, }} /></center>
                        </Container>
                        </div>
                    </div>
                    <TableContainer style={{ height: '250px' }} >
                        <Table stickyHeader className="table-bordered">
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell align='center' className="p-1" >Sl.No</StyledTableCell>
                                    <StyledTableCell align='center' className="p-1" >Job No</StyledTableCell>
                                    <StyledTableCell align='center' className="p-1" >Certificate No</StyledTableCell>
                                    <StyledTableCell align='center' className="p-1" >Certificate Type</StyledTableCell>
                                    <StyledTableCell align='center' className="p-1" >Certificate Date</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                <StyledTableRow>
                                    <StyledTableCell align='center' className="p-1"></StyledTableCell>
                                    <StyledTableCell align='center' className="p-1"></StyledTableCell>
                                </StyledTableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Dialog>
                {/* ./////bond/// */}
                <Dialog open={bondHandleOpen} onClose={bondOnClickClose} fullWidth={true} maxWidth='md'>
                    <DialogTitle align='center' className=" p-1 bg-info" style={{ fontFamily: 'Times New Roman' }}>
                        Add Bond  Details
                    </DialogTitle >
                    <div>
                        <div><Container className="mb-2 mt-4">
                            <Row className='form-inline'>
                                <Col><center><label style={{ fontFamily: 'Times New Roman' }}>Bond No</label></center>
                                    <center><Form.Control size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', width: '150px' }} value={JobAuditingValues.bondNo} onChange={JobAuditingbondNoChangeHandle}
                                    /></center></Col>
                                <Col><center><label style={{ fontFamily: 'Times New Roman' }}>Bond Code</label></center>
                                    <center><Form.Select size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', width: '150px' }} value={JobAuditingValues.bondCode} onChange={JobAuditingbondCodeChangeHandle}>
                                        <option></option>
                                    </Form.Select></center></Col>
                                <Col><center><label style={{ fontFamily: 'Times New Roman' }}>Bond Port</label></center>
                                    <center><Form.Select size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', width: '150px' }} value={JobAuditingValues.bondPort} onChange={JobAuditingbondPortChangeHandle}>
                                        <option></option>
                                    </Form.Select></center></Col>
                            </Row>
                            <Row>
                                <Col><center><label style={{ fontFamily: 'Times New Roman' }}>Bond Amount</label></center>
                                    <center><Form.Control size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', width: '150px' }}
                                        value={JobAuditingValues.bondAmount} onChange={JobAuditingbondAmountChangeHandle} /></center></Col>
                                <Col><center><label style={{ fontFamily: 'Times New Roman' }}>BG Depited</label></center>
                                    <center> <Form.Control size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', width: '150px' }}
                                        value={JobAuditingValues.bgDebited} onChange={JobAuditingbgDebitedChangeHandle} /></center></Col>
                                <Col><center><label style={{ fontFamily: 'Times New Roman' }}>Bg Rate</label></center>
                                    <center><Form.Control size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', width: '150px' }}
                                        value={JobAuditingValues.bgRate} onChange={JobAuditingbgRateChangeHandle} /></center></Col>
                                <Col><center><label style={{ fontFamily: 'Times New Roman' }}>Bg Amount</label></center>
                                    <center><Form.Control size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', width: '150px' }}
                                        value={JobAuditingValues.bgAmount} onChange={JobAuditingbgAmountChangeHandle} /></center></Col></Row>
                        </Container>
                        </div>
                    </div>
                    <TableContainer style={{ height: '250px' }} >
                        <Table stickyHeader className="table-bordered">
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell align='center' className="p-1" >Sl.No</StyledTableCell>
                                    <StyledTableCell align='center' className="p-1" >Job No</StyledTableCell>
                                    <StyledTableCell align='center' className="p-1" >Bond No</StyledTableCell>
                                    <StyledTableCell align='center' className="p-1" >Bond Code</StyledTableCell>
                                    <StyledTableCell align='center' className="p-1" >Bond Port</StyledTableCell>
                                    <StyledTableCell align='center' className="p-1" >Bond Amount</StyledTableCell>
                                    <StyledTableCell align='center' className="p-1" >BG Depited</StyledTableCell>
                                    <StyledTableCell align='center' className="p-1" >BG Rate</StyledTableCell>
                                    <StyledTableCell align='center' className="p-1" >BG Amount</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                <StyledTableRow>
                                    <StyledTableCell align='center' className="p-1"></StyledTableCell>
                                    <StyledTableCell align='center' className="p-1"></StyledTableCell>
                                </StyledTableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Dialog>
                {/* ...container.../... */}
                <Dialog open={containerHandleOpen} onClose={containerOnClickClose} fullWidth={true} maxWidth='md'>
                    <DialogTitle align='center' className="bg-info p-1" style={{ fontFamily: 'Times New Roman' }}>
                        Add Container  Details
                    </DialogTitle >
                    <Grid container>
                        <Grid xs={4}>
                            <ItemPap style={{ height: '263px' }}>
                                <div><Container className="mb-2 mt-1">
                                    <center><CssTextField size='small' style={{ fontFamily: 'Times New Roman', width: '80%', backgroundColor: 'white' }}
                                        value={JobAuditingValues.containerNo} onChange={JobAuditingcontainerNoChangeHandle}
                                        label="Container No" variant="outlined" /></center>
                                    <center className="mb-2 mt-2"><CssTextField size='small' style={{ fontFamily: 'Times New Roman', width: '80%', backgroundColor: 'white' }}
                                        value={JobAuditingValues.containerSize} onChange={JobAuditingcontainerSizeChangeHandle}
                                        label="Container size" variant="outlined" /></center>
                                    <center className="mb-2 mt-2"><CssTextField size='small' style={{ fontFamily: 'Times New Roman', width: '80%', backgroundColor: 'white' }}
                                        value={JobAuditingValues.lclFcl} onChange={JobAuditinglclFclChangeHandle}
                                        label="LCL/FCL/CCL(L/F/C)" variant="outlined" /></center>
                                    <center className="mb-2 mt-2"><CssTextField size='small' style={{ fontFamily: 'Times New Roman', width: '80%', backgroundColor: 'white' }}
                                        value={JobAuditingValues.sealNo} onChange={JobAuditingsealNoChangeHandle}
                                        label="Seal No" variant="outlined" /></center>
                                    <center className="mb-2 mt-2"><CssTextField size='small' style={{ fontFamily: 'Times New Roman', width: '80%', backgroundColor: 'white' }}
                                        value={JobAuditingValues.truckNo} onChange={JobAuditingtruckNoChangeHandle}
                                        label="Truck No" variant="outlined" /></center>

                                </Container>
                                </div>
                            </ItemPap>
                        </Grid>
                        <Grid xs={8}>
                            <ItemPap style={{ height: '263px' }}>
                                <TableContainer style={{ height: '250px' }} >
                                    <Table stickyHeader className="table-bordered">
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell align='center' className="p-1" >Job No</StyledTableCell>
                                                <StyledTableCell align='center' className="p-1" >Container No</StyledTableCell>
                                                <StyledTableCell align='center' className="p-1" >Size</StyledTableCell>
                                                <StyledTableCell align='center' className="p-1" >LCL FCL</StyledTableCell>
                                                <StyledTableCell align='center' className="p-1" >Seal No</StyledTableCell>
                                                <StyledTableCell align='center' className="p-1" >Truck No</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            <StyledTableRow>
                                                <StyledTableCell align='center' className="p-1"></StyledTableCell>
                                                <StyledTableCell align='center' className="p-1"></StyledTableCell>
                                            </StyledTableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </ItemPap>
                        </Grid>
                    </Grid>
                </Dialog>
                {/* .///HSS/// */}
                <Dialog open={hssHandleOpen} onClose={hssOnClickClose} fullWidth={true} maxWidth='md'>
                    <DialogTitle align='center' className="bg-info p-1" style={{ fontFamily: 'Times New Roman' }}>
                        Add HSS  Details
                    </DialogTitle >
                    <div>
                        <div><Container className="mb-2 mt-2">
                            <Row className='form-inline'>
                                <Col><center><label style={{ fontFamily: 'Times New Roman' }}>IEC Code</label></center>
                                    <center><Form.Select size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', width: '190px' }}
                                        value={JobAuditingValues.iec_code} onChange={JobAuditingiec_codeChangeHandle}>
                                        <option></option>
                                    </Form.Select></center></Col>
                                <Col><center><label style={{ fontFamily: 'Times New Roman' }}>Branch SrNo</label></center>
                                    <center><Form.Select size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', width: '190px' }}
                                        value={JobAuditingValues.branchSrno} onChange={JobAuditingbranchSrnoChangeHandle}>
                                        <option></option>
                                    </Form.Select></center></Col>
                                <Col><center><label style={{ fontFamily: 'Times New Roman' }}>Preceding Level(0/1)</label></center>
                                    <center><Form.Control size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', width: '190px' }}
                                        value={JobAuditingValues.precidingLvl}
                                        onChange={JobAuditingprecidingLvlChangeHandle} /></center></Col>
                            </Row>
                            <Col><center><label style={{ fontFamily: 'Times New Roman' }}>Name</label></center>
                                <center><Form.Control size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black' }}
                                    value={JobAuditingValues.hss_name} onChange={JobAuditinghss_nameChangeHandle} /></center></Col>
                            <Row>
                                <Col><center><label style={{ fontFamily: 'Times New Roman' }}>Address1 </label></center>
                                    <textarea size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', width: '410px' }} rows="3"
                                        value={JobAuditingValues.hss_adres1} onChange={JobAuditinghss_adres1ChangeHandle}></textarea></Col>
                                <Col><center><label style={{ fontFamily: 'Times New Roman' }}>Address2 </label></center>
                                    <textarea size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', width: '410px' }} rows="3"
                                        value={JobAuditingValues.hss_adres2} onChange={JobAuditinghss_adres2ChangeHandle}></textarea></Col>
                            </Row>
                            <Row>
                                <Col><center><label style={{ fontFamily: 'Times New Roman' }}>City</label></center>
                                    <center><Form.Control size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', width: '190px' }}
                                        value={JobAuditingValues.hss_city} onChange={JobAuditinghss_cityChangeHandle} /></center></Col>
                                <Col><center><label style={{ fontFamily: 'Times New Roman' }}>State</label></center>
                                    <center><Form.Control size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', width: '190px' }}
                                        value={JobAuditingValues.hss_state} onChange={JobAuditinghss_stateChangeHandle} /></center></Col>
                                <Col><center><label style={{ fontFamily: 'Times New Roman' }}>Pincode</label></center>
                                    <center><Form.Control size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', width: '190px' }}
                                        value={JobAuditingValues.hss_pincode} onChange={JobAuditinghss_pincodeChangeHandle} /></center></Col>
                            </Row>
                        </Container>
                        </div>
                    </div>
                    <TableContainer style={{ height: '250px' }} >
                        <Table stickyHeader className="table-bordered">
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell align='center' className="p-1" >Sl.No</StyledTableCell>
                                    <StyledTableCell align='center' className="p-1" >Job No</StyledTableCell>
                                    <StyledTableCell align='center' className="p-1" >IEC Code</StyledTableCell>
                                    <StyledTableCell align='center' className="p-1" >Name</StyledTableCell>
                                    <StyledTableCell align='center' className="p-1" >Preceding Level</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                <StyledTableRow>
                                    <StyledTableCell align='center' className="p-1"></StyledTableCell>
                                    <StyledTableCell align='center' className="p-1"></StyledTableCell>
                                </StyledTableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Dialog>
                {/* .///Sec 48/// */}
                <Dialog open={sec48HandleOpen} onClose={sec48OnClickClose} fullWidth={true} maxWidth='md'>
                    <DialogTitle align='center' className="bg-info p-1" style={{ fontFamily: 'Times New Roman' }}>
                        Add SEC-48  Details
                    </DialogTitle >
                    <div>
                        <div><Container className="mb-2 mt-2">
                            <Row className='form-inline'>
                                <Col><center><label style={{ fontFamily: 'Times New Roman' }}>Permission Code</label></center>
                                    <center><Form.Control size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black', width: '190px' }} value={JobAuditingValues.Permissioncode}
                                        onChange={JobAuditingPermissioncodeChangeHandle} /></center></Col>
                            </Row>
                            <Col><center><label style={{ fontFamily: 'Times New Roman' }}>Name</label></center>
                                <center><Form.Control size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black' }} value={JobAuditingValues.addsec48_name} onChange={JobAuditingaddsec48_nameChangeHandle} /></center></Col>
                            <Row>
                                <center><label style={{ fontFamily: 'Times New Roman' }}>Permission Description</label></center>
                                <textarea size='sm' style={{ fontFamily: 'Times New Roman', border: '1px solid black' }} rows="3" value={JobAuditingValues.Permission_Description} onChange={JobAuditingPermission_DescriptionChangeHandle}></textarea>
                            </Row>
                        </Container>
                        </div>
                    </div>
                    <TableContainer style={{ height: '250px' }} >
                        <Table stickyHeader className="table-bordered">
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell align='center' className="p-1" >Sl.No</StyledTableCell>
                                    <StyledTableCell align='center' className="p-1" >Job No</StyledTableCell>
                                    <StyledTableCell align='center' className="p-1" >IEC Code</StyledTableCell>
                                    <StyledTableCell align='center' className="p-1" >Name</StyledTableCell>
                                    <StyledTableCell align='center' className="p-1" >Preceding Level</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                <StyledTableRow>
                                    <StyledTableCell align='center' className="p-1"></StyledTableCell>
                                    <StyledTableCell align='center' className="p-1"></StyledTableCell>
                                </StyledTableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Dialog>
                {/* add-query */}
                <Dialog open={addQuery} onClose={QueryCloseHandle} fullWidth={true} maxWidth='sm'>
                    <DialogTitle className='p-1 bg-light'><center style={{ fontFamily: 'Times New Roman' }}>Add Query</center></DialogTitle>
                    <Container>
                        <Row><Col className='query'>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                <Form.Label style={{ fontFamily: 'Times New Roman' }}>Remarks</Form.Label>
                                <Form.Control style={{ fontFamily: 'Times New Roman' }} as="textarea" rows={3} value={jobAuitDialogValues.remark}
                                    onChange={addQueryRemarksChangehandle} />
                            </Form.Group>
                        </Col>
                        </Row>
                        <center><Button style={{ fontFamily: 'Times New Roman' }} variant='contained' onClick={updateQryRemarks}>Update</Button>
                        </center>
                        <br></br>
                    </Container>
                </Dialog>
                {/* viewInvoice */}
                <Dialog open={viewInvocie} onClose={viewInvoiceDetailsClose} fullWidth={true} maxWidth='md'>
                    <DialogTitle align='center' className="p-1 bg-info" style={{ fontWeight: 'bolder' }}>View Invoice Details</DialogTitle>
                    <center><div className='form-inline'>
                        <lable style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'red', marginTop: '0.5%', marginBottom: '1%' }}>Invoice Details:</lable>
                        <lable style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'darkblue', marginTop: '0.5%', marginBottom: '1%' }}>Total Invoice Value in (INR):</lable>
                    </div></center>
                    <Paper sx={{ height: 105, border: '1px solid black' }}>
                        <TableContainer sx={{ maxHeight: 100 }} className='scrollbarPrime'>
                            <Table stickyHeader className='table table-bordered'>
                                <TableHead>
                                    <StyledTableRow>
                                        <StyledTableCell className='p-1'>Sl</StyledTableCell>
                                        <StyledTableCell className='p-1'>Invoice No</StyledTableCell>
                                        <StyledTableCell className='p-1'>Invoice Value</StyledTableCell>
                                        <StyledTableCell className='p-1'>Invoice Currency</StyledTableCell>
                                        <StyledTableCell className='p-1'>Invoice Value In INR</StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                    {AuditInvDetails.map(item => (
                                        <StyledTableRow hover key={item.serialNumber} >
                                            <StyledTableCell width='30px' className='p-1'>{item.serialNumber}</StyledTableCell>
                                            <StyledTableCell className='p-1'>{item.invoiceNumber}</StyledTableCell>
                                            <StyledTableCell className='p-1'>{item.invoiceVal}</StyledTableCell>
                                            <StyledTableCell className='p-1'>{item.currency_code}</StyledTableCell>
                                            <StyledTableCell className='p-1'>{item.invoiceValINR}</StyledTableCell>
                                        </StyledTableRow>))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Dialog>
                {/* viewItem */}
                <Dialog open={viewItem} onClose={viewItemDetailsClose} fullWidth={true} maxWidth='md'>
                    <DialogTitle align='center' className="p-1 bg-info" style={{ fontWeight: 'bolder' }}>View Item Details</DialogTitle>
                    <center><div className='form-inline'>
                        <lable style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'red', marginTop: '0.5%', marginBottom: '1%' }}>Item Details:</lable>{' '}
                        <lable style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'darkblue', marginTop: '0.5%', marginBottom: '1%' }}>No of Item:</lable>{' '}
                        <lable style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'darkblue', marginTop: '0.5%', marginBottom: '1%' }}>Total Assesable Value:</lable>{' '}
                    </div></center>
                    <Paper sx={{ height: 105, border: '1px solid black' }}>
                        <TableContainer sx={{ maxHeight: 100 }} className='scrollbarPrime'>
                            <Table stickyHeader className='table table-bordered'>
                                <TableHead>
                                    <StyledTableRow>
                                        <StyledTableCell className='p-1'>Sl.No</StyledTableCell>
                                        <StyledTableCell sx={{ width: 500 }} className='p-1'>Item Description</StyledTableCell>
                                        <StyledTableCell className='p-1'>Total Amount</StyledTableCell>
                                        <StyledTableCell className='p-1'>Assessable Value</StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                    {AuditItmDetails.map((item) => (
                                        <StyledTableRow hover key={item.serialNumber}>
                                            <StyledTableCell className='p-1'>{item.serialNumber}</StyledTableCell>
                                            <StyledTableCell sx={{ width: 500 }} className='p-1'>{item.item_description}</StyledTableCell>
                                            <StyledTableCell className='p-1'>{item.totAmt}</StyledTableCell>
                                            <StyledTableCell className='p-1'>{item.assbleValue}</StyledTableCell>
                                        </StyledTableRow>))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Dialog>
            </div >
            <Home />
            <div style={{ paddingLeft: '100px' }}>
            <Row>
                    <Col xs={1}><ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small">
                        <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px', marginLeft: '5px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton></Col>
                    <Col xs={10}></Col>
                    <Col xs={1} style={{textAlign:'end'}}> <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small">
                        <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton>
                    </Col>
                </Row>
                {loading ?
                    <div className="loaderCss">
                        <HashLoader
                            color={"#296cbc"}
                            loading={loading}
                            size={50}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                        />
                    </div>
                    :
                    <Grid container>
                        <Grid item xs={2}>
                            <ItemPap1>
                                {/* <ToggleButton onClick={BackBotton} className='headerstyleStrt'  size="small" >
                             <ArrowBackIosIcon fontSize='small' style={{ fontSize: '16px',marginLeft:'5px' }}/> </ToggleButton> */}
                                <lable style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'red', marginTop: '0.5%', marginBottom: '1%', marginLeft: '18px' }}>Non Audit Job</lable>
                                <TableContainer sx={{ maxHeight: 600 }} className='scrollbarPrime'>
                                    <Table stickyHeader className='table table-bordered'>
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell className='p-1'>Sl.No</StyledTableCell>
                                                <StyledTableCell className='p-1'>Job No {NonauditJobSrch()}</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {Filtereddetails.map(item => {
                                                const isItemSelected = isSelected(item.consignmentId);
                                                return (
                                                    <TableRow hover key={item.consignmentId} tabIndex={-1} selected={isItemSelected} onClick={() => editNonAudit(item)}>
                                                        <StyledTableCell>{item.serialNumber}</StyledTableCell>
                                                        <StyledTableCell>{item.consignmentNumber}</StyledTableCell>
                                                    </TableRow>)
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </ItemPap1>
                        </Grid>
                        <Grid item xs={8}>
                            <ItemPap>
                                <Itemone>
                                    <Paper>
                                        <div className='form-inline Billingtitleclr'>
                                            <center className='mb-2'><lable style={{ fontSize: '20px', fontWeight: 'bold', color: 'red', marginBottom: '2%' }}>JOB DETAILS</lable></center>
                                            <label style={{ fontFamily: 'Times New Roman', color: 'darkblue' }}>JOB.NO</label>{' '}
                                            <input style={{ fontFamily: 'Times New Roman', height: '26px', width: '100px' }} type='number'
                                                value={JobAuditingValues.jobno} onChange={JobAuditingjobnoChangeHandle} />{' '}
                                            <Button variant='contained' style={{ fontFamily: 'Times New Roman', height: '26px', marginBottom: '0.5%' }} onClick={searchJob}>Search</Button>{'  '}
                                            <label style={{ fontFamily: 'Times New Roman', color: 'darkblue' }}>JOB.NO</label>{' '}
                                            <input disabled style={{ fontFamily: 'Times New Roman', height: '26px', width: '100px', fontWeight: 'Bold', color: 'red' }} value={JobAuditingValues.disable_jobno} />
                                        </div>
                                    </Paper>
                                    <Row>
                                        <Col >
                                            <label className='billingIpTitle'>IEC.Code</label>
                                            <Form.Control value={JobAuditingValues.iec_code} type='number' style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '29px', fontWeight: 'bolder', color: 'blueviolet', textAlign: 'center', fontSize: '18px' }} onChange={JobAuditingieccodeChangeHandle} />
                                        </Col>
                                        <Col>
                                            <label className='billingIpTitle'>Name</label>
                                            <Form.Control value={JobAuditingValues.name} style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '29px', fontWeight: 'bolder', color: 'blueviolet', textAlign: 'center', fontSize: '18px' }} onChange={JobAuditingnameChangeHandle} />
                                        </Col>
                                        <Col >
                                            <label className='billingIpTitle'>CHA Code</label>
                                            <Form.Control value={JobAuditingValues.cha_code} style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '29px', fontWeight: 'bolder', color: 'blueviolet', textAlign: 'center', fontSize: '18px' }} onChange={JobAuditingcha_codeChangeHandle} />
                                        </Col>
                                    </Row>
                                </Itemone>
                                <Itemone className='mt-1'>
                                    <Row>
                                        <Col xs={2}>
                                            <label className='billingIpTitle'>Branch.SrNo</label>
                                            <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} type='number' value={JobAuditingValues.branch_Srno} onChange={JobAuditingbranch_SrnoChangeHandle} />
                                        </Col>
                                        <Col>
                                            <label className='billingIpTitle'>Address-1</label>
                                            <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} value={JobAuditingValues.address1} onChange={JobAuditingaddress1ChangeHandle} />
                                        </Col>
                                        <Col >
                                            <label className='billingIpTitle'>Address-2</label>
                                            <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} value={JobAuditingValues.address2} onChange={JobAuditingaddress2ChangeHandle} />
                                        </Col>
                                        <Col xs={3}>
                                            <label className='billingIpTitle'>City</label>
                                            <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} value={JobAuditingValues.city} onChange={JobAuditingcityChangeHandle} />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <label className='billingIpTitle'>State</label>
                                            <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} value={JobAuditingValues.state} onChange={JobAuditingstateChangeHandle} />
                                        </Col>
                                        <Col>
                                            <label className='billingIpTitle'>PinCode</label>
                                            <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} type='number' value={JobAuditingValues.pincode} onChange={JobAuditingpincodeChangeHandle} />
                                        </Col>
                                        <Col>
                                            <label className='billingIpTitle'>AdCode</label>
                                            <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} type='number' value={JobAuditingValues.adcode} onChange={JobAuditingadcodeChangeHandle} />
                                        </Col>
                                        <Col>
                                            <label className='billingIpTitle'>EdiJob.No</label>
                                            <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} type='number' value={JobAuditingValues.edi_jobNo} onChange={JobAuditingedi_jobNoChangeHandle} />
                                        </Col>
                                    </Row>
                                </Itemone>
                                <Itemone className='mt-1'>
                                    <Row>
                                        <Col xs={2}>
                                            <label className='billingIpTitle'>CusHouse Code</label>
                                            <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} value={JobAuditingValues.cusHouseCode} onChange={JobAuditingcusHouseCodeChangeHandle} />
                                        </Col>
                                        <Col xs={5}>
                                            <label className='billingIpTitle'> </label>
                                            <Form.Control disabled style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} value={JobAuditingValues.disable_cusHouseCode} onChange={JobAuditingdisable_cusHouseCodeChangeHandle} />
                                        </Col>
                                        <Col>
                                            <label className='billingIpTitle'>Branch</label>
                                            <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} value={JobAuditingValues.branch} onChange={JobAuditingbranchChangeHandle} />
                                        </Col>
                                        <Col>
                                            <label className='billingIpTitle'>Forwarder</label>
                                            <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} value={JobAuditingValues.forwarder} onChange={JobAuditingforwarderChangeHandle} />
                                        </Col>
                                    </Row>
                                </Itemone>
                                <Itemone className='mt-1'>
                                    <Row>
                                        <Col></Col>
                                        <Col xs={2}>
                                            <label className='billingIpTitle'>TransitMode</label>
                                            <Row>
                                                <Col xs={5}><Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} value={JobAuditingValues.transist_mode}
                                                    onChange={JobAuditingtransist_modeChangeHandle} /></Col>
                                                <Col><Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', height: '26px', textAlign: 'center', fontWeight: 'bold' }} disabled value={JobAuditingValues.disable_transist_mode} onChange={JobAuditingdisable_transist_modeChangeHandle} /></Col>
                                            </Row>
                                        </Col>
                                        <Col xs={2}>
                                            <label className='billingIpTitle'>Certificate</label>
                                            <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', textTransform: 'uppercase', textAlign: 'center', height: '26px', fontWeight: 'bold' }}
                                                onKeyDown={JobAud_certificateOnkeyDown} value={JobAuditingValues.certificate} onChange={JobAuditingcertificateChangeHandle} />
                                        </Col>
                                        <Col xs={2}>
                                            <label className='billingIpTitle'>Bond</label>
                                            <Form.Control style={{ fontFamily: 'Times New Roman', border: '1px solid black', textTransform: 'uppercase', textAlign: 'center', height: '26px', fontWeight: 'bold' }} onKeyDown={JobAud_bondOnkeyDown} value={JobAuditingValues.bond} onChange={JobAuditingbondChangeHandle} />
                                        </Col>
                                        <Col xs={2}>
                                            <label className='billingIpTitle'>Container</label>
                                            <Form.Control style={{ fontFamily: 'Times New Roman', height: '26px', border: '1px solid black', textTransform: 'uppercase', textAlign: 'center', fontWeight: 'bold' }} onKeyDown={JobAud_containerOnkeyDown} value={JobAuditingValues.container} onChange={JobAuditingcontainerChangeHandle} />
                                        </Col>
                                        <Col xs={2}>
                                            <label className='billingIpTitle'>BE Type</label>
                                            <Form.Control style={{ fontFamily: 'Times New Roman', height: '26px', border: '1px solid black', textTransform: 'uppercase', textAlign: 'center', fontWeight: 'bold' }} value={JobAuditingValues.betype} onChange={JobAuditingbetypeChangeHandle} />
                                        </Col>
                                        <Col></Col>
                                    </Row>
                                    <Row>
                                        <Col></Col>
                                        <Col xs={2}>
                                            <label className='billingIpTitle'>Kacha</label>
                                            <Form.Control style={{ fontFamily: 'Times New Roman', height: '26px', border: '1px solid black', textTransform: 'uppercase', textAlign: 'center', fontWeight: 'bold' }} value={JobAuditingValues.kacha} onChange={JobAuditingkachaChangeHandle} />
                                        </Col>
                                        <Col xs={2}>
                                            <label className='billingIpTitle'>HSS</label>
                                            <Form.Control style={{ fontFamily: 'Times New Roman', height: '26px', border: '1px solid black', textTransform: 'uppercase', textAlign: 'center', fontWeight: 'bold' }} onKeyDown={JobAud_hssOnkeyDown} value={JobAuditingValues.hss} onChange={JobAuditinghssChangeHandle} />
                                        </Col>
                                        <Col xs={2}>
                                            <label className='billingIpTitle'>Sec-48</label>
                                            <Form.Control style={{ fontFamily: 'Times New Roman', height: '26px', border: '1px solid black', textTransform: 'uppercase', textAlign: 'center', fontWeight: 'bold' }} onKeyDown={JobAud_sec48OnkeyDown} value={JobAuditingValues.sec48} onChange={JobAuditingsec48ChangeHandle} />
                                        </Col>
                                        <Col xs={2}>
                                            <label className='billingIpTitle'>BE No</label>
                                            <Form.Control style={{ fontFamily: 'Times New Roman', height: '26px', border: '1px solid black', textTransform: 'uppercase', textAlign: 'center', fontWeight: 'bold' }} value={JobAuditingValues.beNo} onChange={JobAuditingbeNoChangeHandle} />
                                        </Col>
                                        <Col xs={2}>
                                            <label className='billingIpTitle'>BE Date</label>
                                            <Form.Control style={{ fontFamily: 'Times New Roman', height: '26px', border: '1px solid black', textTransform: 'uppercase', textAlign: 'center', fontWeight: 'bold' }} type='date' value={JobAuditingValues.BeDate} onChange={JobAuditingBeDateChangeHandle} />
                                        </Col>
                                        <Col></Col>
                                    </Row>
                                </Itemone>
                                <div className='mt-5'>
                                    <Button variant='contained' style={{ fontFamily: 'Times New Roman' }} onClick={audit} disabled={auditdsa}>{Auditt ? 'processing..' : 'Audit'}</Button>{' '}
                                    <Button variant='contained' style={{ fontFamily: 'Times New Roman' }} onClick={Nonaudit} disabled={Nonauditdsa}>{Nonauditt ? 'processing..' : 'Non Audit'}</Button>{' '}
                                    <Button variant='contained' style={{ fontFamily: 'Times New Roman' }} onClick={QueryOpenHandle} disabled={Querydsa}>{Query ? 'processing..' : 'Query'}</Button>{' '}
                                    <Button variant='contained' style={{ fontFamily: 'Times New Roman' }} onClick={resetall}>Cancel</Button>{' '}
                                    <Button variant='contained' style={{ fontFamily: 'Times New Roman' }} onClick={viewInvoiceDetailsOpen}>View Invoice Details</Button>{' '}
                                    <Button variant='contained' style={{ fontFamily: 'Times New Roman' }} onClick={viewItemDetailsOpen}>View Item Details</Button>{' '}
                                </div>
                            </ItemPap>
                        </Grid>
                        <Grid item xs={2}>
                            <ItemPap2>
                                <lable style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'red', marginTop: '0.5%', marginBottom: '1%', marginRight: '50px' }}>Audit Job</lable>
                                {/* <ToggleButton onClick={ForwordBotton} size="small" className='headerstyleEND'>  
                            <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px'}} /> </ToggleButton>  */}
                                <TableContainer sx={{ maxHeight: 600 }} className='scrollbarPrime'>
                                    <Table stickyHeader className='table table-bordered'>
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell className='p-1'>Sl.No</StyledTableCell>
                                                <StyledTableCell className='p-1'>Job No {auditJobSrch()}</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {auditFiltereddetails.map((item) => {
                                                const isItemSelected = isitemSelected(item.consignmentId);
                                                return (
                                                    <TableRow hover key={item.consignmentId} tabIndex={-1} selected={isItemSelected} onClick={() => editAudit(item)}>
                                                        <StyledTableCell>{item.serialNumber}</StyledTableCell>
                                                        <StyledTableCell>{item.consignmentNumber}</StyledTableCell>
                                                    </TableRow>)
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </ItemPap2>
                        </Grid>
                    </Grid>}
            </div>
        </div >
    )
}

export default JobAuditing